import ReactOnRails from 'react-on-rails/client';
import SpotDetail from '../../bundles/SpotDetail/components/SpotDetail.client.jsx';

ReactOnRails.register({SpotDetail});